import {
  Box,
  Coin,
  EmptyState,
  EmptyStateDescription,
  EmptyStateGraphic,
  EmptyStateTitle,
  Icon,
} from '@customerio/pluma-components/react';

// A colleague may open this URL before their account has the flag; a 404 would look like a broken link, not missing access.
export function NoAccess() {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" h="full" w="full">
      <EmptyState>
        <EmptyStateGraphic>
          <Coin size="lg" shape="rounded-square" colorVariant="purple">
            <Icon name="goal" />
          </Coin>
        </EmptyStateGraphic>
        <EmptyStateTitle>Outcome Optimization</EmptyStateTitle>
        <EmptyStateDescription>
          This is an internal preview. Ask in #proj-goal-optimization to get access.
        </EmptyStateDescription>
      </EmptyState>
    </Box>
  );
}
